import { render, staticRenderFns } from "./Timestamp.vue?vue&type=template&id=51430893&scoped=true&"
import script from "./Timestamp.vue?vue&type=script&lang=ts&"
export * from "./Timestamp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51430893",
  null
  
)

export default component.exports